<script lang="ts">
	import { getHubStores } from '$lib/stores/hubStores';
	import { getFonts } from '$lib/utils/globalCssFromBE';

	const { hub } = getHubStores();
	const { hubBodyFont } = getFonts($hub.theme);
</script>

{#if $hub.footer_links?.length}
	<div style="block-size: 40px" />
	<footer
		class="px-sparq-footer footer"
		style="background-color: {$hub.theme.footerBackgroundColor}">
		<ul>
			{#each $hub.footer_links as link}
				<li>
					<a
						href={link.href}
						style="color: {$hub.theme.footerFontColor};font:{hubBodyFont};font-size:inherit"
						>{link.title}</a>
				</li>
			{/each}
		</ul>
	</footer>
{/if}

<style>
	.footer {
		display: flex;
		position: fixed;
		z-index: var(--z-index-Footer);
		align-items: center;
		justify-content: center;
		inline-size: 100%;
		margin-block-start: auto;
		inset-block-end: 0;
	}

	li {
		margin-block: var(--gutterSmall);
		margin-inline: 0;
		padding-block: 0;
		padding-inline: 20px;
		font-size: var(--fontSizeSmaller);
		letter-spacing: 0.4px;
		border-inline-start: solid 1px var(--LIGHT_GRAY);
	}

	ul {
		display: flex;
		flex-wrap: nowrap;
		margin: 0;
		padding: 0;
		list-style: none;
	}

	ul > li:first-child {
		border-inline-start: none;
	}

	a {
		text-decoration: none;
	}

	@media (max-width: 575px) {
		li {
			padding-block: 0;
			padding-inline: 10px;
			font-size: var(--fontSizeSmaller);
		}
	}
</style>
